import { render } from "./TrophiesView.vue?vue&type=template&id=06c15136&scoped=true"
import script from "./TrophiesView.vue?vue&type=script&lang=js"
export * from "./TrophiesView.vue?vue&type=script&lang=js"

import "./TrophiesView.vue?vue&type=style&index=0&id=06c15136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c15136"]])

export default __exports__